// @flow
import { makeGetRequest } from '../utils'

import type { ResponseAPI } from '../types/api'
import type { Genre } from '../types/genres'

export const getChannelGenres = (domain: string, serviceSpec: string): Promise<ResponseAPI<Genre>> =>
  makeGetRequest(`${domain}/client/api/servicespec/${serviceSpec}/tv/genres`)
